import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { TextareaModule } from 'primeng/textarea';
import { FileUploadModule } from 'primeng/fileupload';
import { EditorModule } from 'primeng/editor';
import { SelectModule } from 'primeng/select';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../layout/service/user.service';
import { PdfExtractorService } from './pdf-extractor.service';


@Component({
    selector: 'app-edit-article',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        InputTextModule,
        TextareaModule,
        CardModule,
        DividerModule,
        ToastModule,
        FileUploadModule,
        EditorModule,
        SelectModule
    ],
    providers: [MessageService],
    template: `
        <div class="min-h-screen bg-gray-50 p-4">
            <div class="max-w-5xl mx-auto">
                <div class="bg-white rounded-lg shadow-sm border border-gray-200">
                    <!-- Header -->
                    <div class="flex justify-between items-center p-6 border-b border-gray-200">
                        <div>
                            <h2 class="text-2xl font-bold text-gray-900 flex items-center">
                                <i class="pi pi-pencil mr-2 text-blue-600"></i>
                                Edit Artikel
                            </h2>
                            <p class="text-gray-600 mt-2">Ubah konten artikel</p>
                        </div>
                    </div>

                    <!-- Loading State -->
                    <div *ngIf="loading" class="p-12 text-center">
                        <i class="pi pi-spin pi-spinner text-3xl text-blue-600"></i>
                        <p class="mt-4 text-gray-600">Memuat data artikel...</p>
                    </div>

                    <!-- Form Content -->
                    <div *ngIf="!loading" class="p-6">
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <!-- Sidebar Form (Metadata) -->
                            <div class="md:col-span-1 space-y-6">
                                <div class="bg-white border border-gray-200 rounded-lg p-5">
                                    <h3 class="text-md font-semibold text-gray-900 mb-4 border-b pb-2">Metadata</h3>
                                    
                                    <div class="mb-4">
                                        <label class="block text-sm font-medium text-gray-700 mb-1">
                                            Kategori <span class="text-red-500">*</span>
                                        </label>
                                        <p-select
                                            [(ngModel)]="articleForm.kategori"
                                            [options]="categoryOptions"
                                            optionLabel="label"
                                            optionValue="value"
                                            placeholder="Pilih atau ketik kategori"
                                            [editable]="true"
                                            class="w-full">
                                        </p-select>
                                    </div>
                                    
                                    <div class="mb-4">
                                        <label class="block text-sm font-medium text-gray-700 mb-1">
                                            Slug <span class="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            pInputText
                                            [(ngModel)]="articleForm.slug"
                                            [readonly]="true"
                                            placeholder="contoh-slug-artikel"
                                            class="w-full bg-gray-100 text-gray-600 cursor-not-allowed border-gray-200">
                                        <small class="text-gray-500">Dibuat otomatis dari judul</small>
                                    </div>
                                    
                                    <div class="mb-4">
                                        <label class="block text-sm font-medium text-gray-700 mb-1">
                                            Penulis (Author) <span class="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            pInputText
                                            [(ngModel)]="articleForm.author"
                                            placeholder="Nama Penulis"
                                            class="w-full">
                                    </div>
                                    
                                    <div class="mb-4">
                                        <label class="block text-sm font-medium text-gray-700 mb-1">
                                            Waktu Baca <span class="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            pInputText
                                            [(ngModel)]="articleForm.read_time"
                                            placeholder="Contoh: 5 Menit"
                                            class="w-full">
                                    </div>

                                    <div class="mb-4">
                                        <label class="block text-sm font-medium text-gray-700 mb-1">
                                            Tanggal <span class="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="date"
                                            [(ngModel)]="articleForm.tanggal"
                                            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                                    </div>
                                </div>
                                
                                <div class="bg-white border border-gray-200 rounded-lg p-5">
                                    <h3 class="text-md font-semibold text-gray-900 mb-4 border-b pb-2">Gambar Sampul</h3>
                                    
                                    <div *ngIf="currentImage" class="mb-4">
                                        <label class="block text-sm font-medium text-gray-700 mb-2">Gambar Saat Ini</label>
                                        <img [src]="currentImage" alt="Gambar Artikel" class="w-full h-32 object-cover rounded-lg border border-gray-200">
                                    </div>

                                    <!-- Upload Gambar -->
                                    <div>
                                        <label class="block text-sm font-medium text-gray-700 mb-2">Ganti Gambar (Opsional)</label>
                                        <p-fileUpload
                                            mode="basic"
                                            accept="image/*"
                                            [maxFileSize]="5242880"
                                            (onSelect)="onImageSelect($event)"
                                            [auto]="false"
                                            chooseLabel="Pilih Gambar Baru"
                                            class="w-full block">
                                        </p-fileUpload>
                                        <small class="text-gray-500 mt-2 block">Maksimal 5MB, format: JPG, PNG, WEBP.</small>
                                        <div *ngIf="selectedImage" class="mt-2 text-sm text-green-600 truncate">
                                            File dipilih: {{ selectedImage.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Main Form -->
                            <div class="md:col-span-2">
                                <div class="bg-white border border-gray-200 rounded-lg p-6">
                                    <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                                        <i class="pi pi-file-edit mr-2 text-blue-600"></i>
                                        Konten Artikel
                                    </h3>

                                    <!-- Judul -->
                                    <div class="mb-6">
                                        <label class="block text-sm font-medium text-gray-700 mb-2">
                                            Judul Artikel <span class="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            pInputText
                                            [(ngModel)]="articleForm.judul"
                                            (ngModelChange)="generateSlug()"
                                            placeholder="Masukkan judul artikel..."
                                            class="w-full text-lg font-semibold">
                                    </div>

                                    <!-- Excerpt -->
                                    <div class="mb-6">
                                        <label class="block text-sm font-medium text-gray-700 mb-2">
                                            Ringkasan (Excerpt) <span class="text-red-500">*</span>
                                        </label>
                                        <textarea
                                            pInputTextarea
                                            [(ngModel)]="articleForm.excerpt"
                                            placeholder="Tulis ringkasan singkat artikel..."
                                            rows="3"
                                            class="w-full">
                                        </textarea>
                                    </div>

                                    <!-- Konten -->
                                    <div class="mb-6">
                                        <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-2">
                                            <label class="block text-sm font-medium text-gray-700">
                                                Isi Konten Artikel <span class="text-red-500">*</span>
                                            </label>
                                            <div class="flex items-center gap-2">
                                                <input #pdfInput type="file" accept="application/pdf" (change)="onPdfSelected($event)" class="hidden" />
                                                <button
                                                    type="button"
                                                    (click)="pdfInput.click()"
                                                    [disabled]="isExtractingPdf"
                                                    class="inline-flex items-center gap-2 px-3 py-1.5 text-xs font-semibold rounded-md text-red-700 bg-red-50 hover:bg-red-100 border border-red-200 transition-colors shadow-sm disabled:opacity-50 cursor-pointer">
                                                    <i class="pi pi-file-pdf text-red-600"></i>
                                                    <span>{{ isExtractingPdf ? 'Mengekstrak PDF...' : 'Impor dari PDF' }}</span>
                                                </button>
                                            </div>
                                        </div>

                                        <!-- Extraction Progress Alert -->
                                        <div *ngIf="isExtractingPdf" class="mb-3 p-3 bg-red-50 border border-red-200 rounded-lg text-red-800 text-sm">
                                            <div class="flex items-center justify-between mb-1.5">
                                                <span class="flex items-center gap-2 font-medium">
                                                    <i class="pi pi-spin pi-spinner text-red-600"></i>
                                                    {{ pdfExtractStatus }}
                                                </span>
                                                <span class="font-bold">{{ pdfExtractProgress }}%</span>
                                            </div>
                                            <div class="w-full bg-red-200 rounded-full h-1.5 overflow-hidden">
                                                <div class="bg-red-600 h-1.5 rounded-full transition-all duration-300" [style.width.%]="pdfExtractProgress"></div>
                                            </div>
                                        </div>

                                        <!-- Extraction Success Info -->
                                        <div *ngIf="extractedPdfInfo" class="mb-3 p-3 bg-emerald-50 border border-emerald-200 rounded-lg text-emerald-800 text-xs flex items-center justify-between">
                                            <div class="flex items-center gap-2">
                                                <i class="pi pi-check-circle text-emerald-600 text-base"></i>
                                                <span>
                                                    Berhasil mengimpor teks PDF: <strong>{{ extractedPdfInfo.fileName }}</strong> ({{ extractedPdfInfo.pageCount }} halaman). Teks otomatis terstruktur ke editor.
                                                </span>
                                            </div>
                                            <button type="button" (click)="extractedPdfInfo = null" class="text-emerald-700 hover:text-emerald-900 p-1">
                                                <i class="pi pi-times"></i>
                                            </button>
                                        </div>

                                        <p-editor 
                                            [(ngModel)]="articleForm.konten" 
                                            [style]="{'height':'400px'}"
                                            placeholder="Tulis isi artikel secara lengkap di sini...">
                                        </p-editor>
                                    </div>

                                    <hr class="my-6 border-gray-200">

                                    <!-- Actions -->
                                    <div class="flex justify-end space-x-3">
                                        <p-button
                                            (onClick)="cancel()"
                                            severity="secondary"
                                            icon="pi pi-times"
                                            label="Batal"
                                            [outlined]="true"
                                        ></p-button>
                                        <p-button
                                            (onClick)="save()"
                                            severity="success"
                                            icon="pi pi-save"
                                            label="Simpan Perubahan"
                                            [loading]="saving"
                                        ></p-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <p-toast></p-toast>
    `
})
export class EditArticle implements OnInit {
    articleId: string | null = null;
    loading = true;
    saving = false;
    currentImage: string | null = null;

    articleForm = {
        id: '',
        slug: '',
        kategori: '',
        judul: '',
        excerpt: '',
        konten: '',
        tanggal: '',
        author: '',
        read_time: ''
    };

    selectedImage: File | null = null;
    categoryOptions: { label: string; value: string }[] = [];

    // PDF Extraction States
    isExtractingPdf = false;
    pdfExtractProgress = 0;
    pdfExtractStatus = '';
    extractedPdfInfo: { fileName: string; pageCount: number } | null = null;

    constructor(
        private messageService: MessageService,
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private pdfExtractor: PdfExtractorService
    ) {}

    ngOnInit() {
        this.checkUserAuthorization();
        this.loadCategories();
        this.articleId = this.route.snapshot.paramMap.get('id');
        if (this.articleId) {
            this.loadArticle();
        } else {
            this.router.navigate(['/app/article/list']);
        }
    }

    loadCategories() {
        this.userService.getAdminKategori().then(
            (response) => {
                if (response && response.data && Array.isArray(response.data)) {
                    const activeCategories = response.data
                        .filter((item: any) => String(item.IS_ACTIVED) === '1' && item.KATEGORI)
                        .map((item: any) => item.KATEGORI.trim())
                        .filter((cat: string) => cat.length > 0);
                    
                    const uniqueCategories = Array.from(new Set<string>(activeCategories)).sort();
                    this.categoryOptions = uniqueCategories.map(cat => ({ label: cat, value: cat }));

                    if (this.articleForm.kategori && !this.categoryOptions.some(opt => opt.value === this.articleForm.kategori)) {
                        this.categoryOptions.unshift({ label: this.articleForm.kategori, value: this.articleForm.kategori });
                    }
                }
            },
            (error) => {
                console.error('Error loading article categories:', error);
            }
        );
    }

    checkUserAuthorization() {
        try {
            const userData = localStorage.getItem('user');
            if (userData) {
                const user = JSON.parse(userData);
                if (user.ID_ACCESS_ROLE !== 'N2FWBVCZUE' && user.ID_ACCESS_ROLE !== '4AEJ1KAJTY') {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Akses Ditolak',
                        detail: 'Anda tidak memiliki izin untuk mengakses halaman ini'
                    });
                    this.router.navigate(['/app/article']);
                    return;
                }
            } else {
                this.router.navigate(['/auth/login']);
                return;
            }
        } catch (error) {
            console.error('Error checking user authorization:', error);
            this.router.navigate(['/auth/login']);
        }
    }

    loadArticle() {
        this.loading = true;
        this.userService.getArticles('', parseInt(this.articleId!)).then(
            (response) => {
                const articles = response.data || response;
                if (articles && articles.length > 0) {
                    const article = articles.find((a: any) => a.id == this.articleId) || articles[0];
                    this.articleForm = {
                        id: article.id,
                        slug: article.slug,
                        kategori: article.kategori,
                        judul: article.judul,
                        excerpt: article.excerpt,
                        konten: article.konten,
                        tanggal: article.tanggal ? article.tanggal.split(' ')[0] : '', // Extract just the date
                        author: article.author,
                        read_time: article.read_time
                    };
                    if (article.gambar) {
                        this.currentImage = 'https://oscemediko.id/api-timer/' + article.gambar;
                    }
                } else {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Artikel tidak ditemukan'
                    });
                    this.router.navigate(['/app/article/list']);
                }
                this.loading = false;
            },
            (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Gagal memuat artikel'
                });
                this.loading = false;
                this.router.navigate(['/app/article/list']);
            }
        );
    }
    
    generateSlug() {
        if (!this.articleForm.judul) {
            this.articleForm.slug = '';
            return;
        }
        this.articleForm.slug = this.articleForm.judul
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)+/g, '');
    }

    onImageSelect(event: any) {
        this.selectedImage = event.files[0];
    }

    async onPdfSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) return;
        const file = input.files[0];

        if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Format Salah',
                detail: 'Harap pilih file berformat PDF (.pdf)'
            });
            input.value = '';
            return;
        }

        this.isExtractingPdf = true;
        this.pdfExtractProgress = 10;
        this.pdfExtractStatus = 'Membuka dokumen PDF...';

        try {
            const result = await this.pdfExtractor.extractPdf(file, (percent, msg) => {
                this.pdfExtractProgress = percent;
                this.pdfExtractStatus = msg;
            });

            if (!result.htmlContent || result.htmlContent.trim().length === 0) {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'PDF Tidak Mengandung Teks',
                    detail: 'Teks tidak ditemukan dalam dokumen PDF ini. Pastikan PDF bukan hasil scan murni tanpa layer teks (OCR).'
                });
            } else {
                if (this.articleForm.konten && this.articleForm.konten.trim().length > 0) {
                    this.articleForm.konten += '<br/><hr/><br/>' + result.htmlContent;
                } else {
                    this.articleForm.konten = result.htmlContent;
                }

                if (!this.articleForm.judul && result.suggestedTitle) {
                    this.articleForm.judul = result.suggestedTitle;
                    this.generateSlug();
                }

                if (!this.articleForm.excerpt) {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = result.htmlContent;
                    const plain = (tempDiv.textContent || tempDiv.innerText || '').trim().replace(/\s+/g, ' ');
                    this.articleForm.excerpt = plain.length > 200 ? plain.substring(0, 197) + '...' : plain;
                }

                if (!this.articleForm.read_time) {
                    const wordCount = (this.articleForm.konten.replace(/<[^>]*>/g, ' ').match(/\S+/g) || []).length;
                    const minutes = Math.max(1, Math.ceil(wordCount / 200));
                    this.articleForm.read_time = `${minutes} Menit`;
                }

                this.extractedPdfInfo = {
                    fileName: file.name,
                    pageCount: result.pageCount
                };

                this.messageService.add({
                    severity: 'success',
                    summary: 'Ekstraksi PDF Berhasil',
                    detail: `Isi dari ${result.pageCount} halaman PDF berhasil dimasukkan ke editor artikel.`
                });
            }
        } catch (error: any) {
            console.error('Error extracting PDF:', error);
            this.messageService.add({
                severity: 'error',
                summary: 'Gagal Membaca PDF',
                detail: 'Terjadi kendala saat membaca dokumen PDF: ' + (error?.message || 'Format tidak didukung')
            });
        } finally {
            this.isExtractingPdf = false;
            input.value = '';
        }
    }

    save() {
        if (!this.articleForm.judul || !this.articleForm.kategori || !this.articleForm.slug || !this.articleForm.konten) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Harap lengkapi judul, kategori, slug, dan konten.'
            });
            return;
        }

        this.saving = true;

        const formData = new FormData();
        formData.append('id', this.articleForm.id);
        
        if (this.selectedImage) {
            formData.append('gambar', this.selectedImage);
        }
        
        formData.append('slug', this.articleForm.slug);
        formData.append('kategori', this.articleForm.kategori);
        formData.append('judul', this.articleForm.judul);
        formData.append('excerpt', this.articleForm.excerpt);
        formData.append('konten', this.articleForm.konten);
        formData.append('tanggal', this.articleForm.tanggal);
        formData.append('author', this.articleForm.author);
        formData.append('read_time', this.articleForm.read_time);

        this.userService.updateArticle(formData).then(
            (response) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Berhasil',
                    detail: 'Artikel berhasil diperbarui'
                });
                this.saving = false;
                this.router.navigate(['/app/article/list']);
            },
            (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Gagal memperbarui artikel: ' + (error.error?.message || error.message)
                });
                this.saving = false;
            }
        );
    }

    cancel() {
        this.router.navigate(['/app/article/list']);
    }
}
